import { render, staticRenderFns } from "./Recibos.vue?vue&type=template&id=3017edc1&scoped=true"
import script from "./Recibos.vue?vue&type=script&lang=js"
export * from "./Recibos.vue?vue&type=script&lang=js"
import style0 from "./Recibos.vue?vue&type=style&index=0&id=3017edc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017edc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3017edc1')) {
      api.createRecord('3017edc1', component.options)
    } else {
      api.reload('3017edc1', component.options)
    }
    module.hot.accept("./Recibos.vue?vue&type=template&id=3017edc1&scoped=true", function () {
      api.rerender('3017edc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recibos/Recibos.vue"
export default component.exports